<section id="main-container">
  <div id="main" class="col-xs-12">
      <app-breadcrumb currentPage="Minhas Fichas" routerCurrentPage="/ficha" [currentPageDetail]="fichaTimeline?.proposta?.cliente?.nomeCliente">
          <a *ngIf="isResultadoParcialCurrent" class="remove-ficha" (click)="openModalExcluirFicha()" title="Excluir Ficha">
              <span class="fa fa-trash"></span> Excluir
          </a>
      </app-breadcrumb>

      <app-loader-circles *ngIf="isBuscando"></app-loader-circles>

      <div *ngIf="fichaTimeline && fichaTimeline.timeline" id="client-track" class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-10 col-lg-offset-1 col-xl-8 col-xl-offset-2"
            style="margin-bottom: 50px;">
              <app-banner-timeline [fichaTimeline]="fichaTimeline" (afterSosInverso)="buscarFicha()"></app-banner-timeline>

              <div class="events">
                  <ul class="cp-cdcl timeline">
                      <li *ngFor="let card of fichaTimeline.timeline; let i = index" [className]="className(card)" [ngSwitch]="card.idStatus">
                        <app-card-assinatura *ngSwitchCase="17"  [timeline]="card" [nextCard]="fichaTimeline.timeline[i+1]" [proposta]="fichaTimeline.proposta" (executar)="onAction($event)"></app-card-assinatura>
                        <app-card-timeline *ngSwitchDefault [timeline]="card" [nextCard]="fichaTimeline.timeline[i+1]" [proposta]="fichaTimeline.proposta" (executar)="onAction($event)"></app-card-timeline>
                      </li>
                  </ul>
              </div>
          </div>
      </div>
  </div>
</section>
